import { render, staticRenderFns } from "./NewsModal.vue?vue&type=template&id=fbe173cc&"
import script from "./NewsModal.vue?vue&type=script&lang=js&"
export * from "./NewsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports